/* eslint-disable */
import { useCallback, useState } from 'react';
import { useTranslation } from '../../../locale/useTranslation';
import { ENTITYNAME } from '../../../framework/constant/constant';
import NodeTreeViewForm from '../NodeTreeView/NodeTreeViewForm';
import { TransmissionBrowser } from './TransmissionBrowser';
import { collectionMenuModelAssetOfferLink } from '../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel';
import VodOfferBrowser from '../vodOffer/vodOfferBrowser';

const NodeTreeViewCollection = (props) => {

    const { showTitle = true } = props;

    const lang = useTranslation();

    const [selectedNode, setSelectedNode] = useState({});
    const [selectedItems, setSelectedItems] = useState([]);

    const [isTransmission, setIsTransmission] = useState(true);
    const [isRefreshOffers, setIsRefreshOffers] = useState(false);

    const urlParams = new URLSearchParams(location?.search ?? "");
    const nodeId = urlParams.get("nodeId") ?? null;

    const handleSelectedNode = (node) => {
        setSelectedNode(node);
        setSelectedItems([]);
    }

    return (
        <>
            {showTitle && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                    }}
                >
                    <h1 className="page-title txt-color-bludeDark">
                        <i
                            className="fa fa-table marlr"
                            style={{ fontSize: "20px", color: "GrayText" }}
                        ></i>
                        <span>{lang.node_browser_page_breadcrumb}</span>
                    </h1>
                    {/* Tabs */}
                    <p>
                        <div className='mb-1 d-flex ml-2' style={{ border: "1px solid #007bff", borderRadius: "14px", overflow: "hidden", marginLeft: "auto", height: "26px", cursor: "pointer" }} >
                            <div onClick={() => setIsTransmission(true)} style={{ flex: 1, fontSize: "11px", textAlign: "center", lineHeight: "24px", width: "120px", backgroundColor: isTransmission ? "#007bff" : "white", color: isTransmission ? "white" : "#007bff" }} >
                                {lang.transmissions_label}
                            </div>
                            <div onClick={() => setIsTransmission(false)} style={{ flex: 1, fontSize: "11px", textAlign: "center", lineHeight: "24px", backgroundColor: !isTransmission ? "#007bff" : "white", width: "100px", color: !isTransmission ? "white" : "#007bff" }} >
                                {lang.offers_label}
                            </div>
                        </div>
                    </p>
                </div>
            )}
            <div className='row' style={{ margin: 0 }}>
                <div className={selectedItems.length > 0 ? 'col-2' : 'col-3'}>
                    <NodeTreeViewForm setIsRefreshOffers={setIsRefreshOffers} selectedNodeId={nodeId} height="calc(100vh - 150px)" handleSelectedNodes={handleSelectedNode} />
                </div>
                <div className={'col-9'}>
                    {/* Switch between transmission and offer browser */}
                    {isTransmission ?
                        <TransmissionBrowser gridStyle={{ height: 'calc(100vh - 360px)' }} selectedNode={selectedNode} query={["nodes._id", 'in', [selectedNode._id]]} showTitle={false} title={lang.transmission_browser_page_breadcrumb} entityname={ENTITYNAME.Transmissions} showEdit={false} showAdd={false} menuModel={collectionMenuModelAssetOfferLink} />
                        : <div className='p-3' style={{ backgroundColor: "white" }}>
                            <VodOfferBrowser
                                mainStyle={{ height: 'calc(100vh - 180px)' }}
                                gridstyle={{ height: 'calc(100vh - 325px)' }}
                                showBack={false}
                                selectedNode={selectedNode}
                                showEdit={false}
                                showAdd={false}
                                isRefreshOffers={isRefreshOffers}
                                setIsRefreshOffers={setIsRefreshOffers}
                            />
                        </div>
                    }
                </div>
            </div>
        </>
    );
};

export default NodeTreeViewCollection;
